import { useQuery } from 'react-query';
import { useToastError } from 'lib/hooks/useToastError';
import { wheelsTvKeys } from './wheelsTvKeys';
import { EXPRESS_API } from 'configs/api/expressApi';

interface WtvFiltersResponse {
  filters: Filter[];
}

interface Filter {
  key: string;
  type: string;
  label: string;
  name: string;
  options: { value: string; label: string; group?: string }[];
}

const getWtvFilters = async (): Promise<WtvFiltersResponse> => {
  return (await EXPRESS_API.get(`/wtv/filters`)).data;
};

export const useWtvFiltersQuery = () => {
  const { showError } = useToastError();

  return useQuery(wheelsTvKeys.filters(), () => getWtvFilters(), {
    onError: showError,
    refetchOnMount: true,
  });
};
